import { styled,Box } from '@mui/system';

import { Grid } from '@mui/material';

export const WeekdaysContainer = styled('div')({
  display       : 'flex',
  flexDirection : 'row',
});

export const Weekdays = styled(Grid)(({ theme }) => ({
  color      : theme.palette.primary.gray4,
  fontWeight : 700,
  fontFamily : 'Montserrat',
  marginTop  : '18px',
}));

export const Weekday = styled(Box)({
  display        : 'flex',
  justifyContent : 'center',
  p              : '15px',
  color          : '#BABABA',
  fontFamily     : 'Montserrat',
  fontStyle      : 'normal',
  fontWeight     : 700,
  fontSize       : '14px',
  lineHeight     : '22px',
});

export const WeekdayContainer = styled('div')({
  display  : 'flex',
  flexWrap : 'wrap',
  padding  : '14px 40px 40px 55px',
});

export const Title = styled(Box)(({ theme }) => ({
  display        : 'flex',
  justifyContent : 'center',
  color          : theme.palette.primary.gray8,
  fontFamily     : 'Montserrat',
  fontStyle      : 'normal',
  fontWeight     : 700,
  fontSize       : '16px',
  lineHeight     : '25px',
  marginTop      : '30px',
}));

export const Container = styled(Box)(({ theme }) => ({
  width        : '446px',
  height       : '416px',
  border       : '1px solid ' + theme.palette.primary.gray3,
  borderRadius : '10px',
}));

export const MonthDay = styled(Box)(({ theme }) => ({
  maxWidth       : '2.2rem',
  minWidth       : '35px',
  height         : '35px',
  marginTop      : '15px',
  display        : 'flex',
  justifyContent : 'center',
  alignContent   : 'center',
  flexWrap       : 'wrap',
  color          : theme.palette.primary.black,
  fontWeight     : 400,
  fontFamily     : 'Montserrat',
  borderRadius   : '100%',
}));

export const SeparatorLine = styled(Box)(({ theme }) => ({
  display        : 'flex',
  justifyContent : 'center',
  borderTop      : `1px solid ${theme.palette.primary.gray3}`,
  width          : '100%',
}));

export const CalendarContainer = styled(Box)(({ theme }) => ({
  background   : theme.palette.primary.white,
  border       : '1px solid #E9E9E9',
  padding      : '0 20px',
  borderRadius : '10px',
}));

export const Text = styled(Box)(({ theme }) => ({
  display    : 'flex',
  paddingTop : '8px',
  color      : theme.palette.primary.black1,
  fontFamily : 'Montserrat',
  fontStyle  : 'normal',
  fontWeight : 400,
  fontSize   : '14px',
  lineHeight : '24px',
}));

export const NoData = styled(Box)(({ theme }) => ({
  display        : 'flex',
  justifyContent : 'center',
  color          : theme.palette.primary.gray8,
  fontFamily     : 'Montserrat',
  fontStyle      : 'normal',
  fontWeight     : 700,
  fontSize       : '16px',
  lineHeight     : '25px',
  margin         : 'auto',
  paddingTop     : '8px',
}));

export const Empty = styled(Box)({
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
  height         : '100%',
});
